export const UPDATE_VIP_TABS = 'UPDATE_VIP_TABS';

export const updateVipTabs = (payload: string[]) => ({
    type: UPDATE_VIP_TABS,
    payload,
});

export default (state = [] as string[], action: ReturnType<typeof updateVipTabs>) =>
    action.type === UPDATE_VIP_TABS ? action.payload : state;
